module.exports = "ux-dialog-footer{justify-content:space-between !important}ux-dialog-footer .secondaryAction{padding:0 !important}";